"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppOrder {
}
exports.default = AppOrder;
//# sourceMappingURL=PromoCode.js.map